import firebase from "firebase/app";

export const courseCatsSubcatsItemsMixin = {
  data() {
    return {
      vimeoidsToMarkAsWatched: [],
      staticListOfCourseData: []
    };
  },
  methods: {
    // mthMixinFillStaticListOfCourseData() {
    //   this.courseFirebaseData.newOrEditedCourseDetails.forEach(el => {
    //     this.staticListOfCourseData.push(el.data)
    //   });
    //   console.log('my static list is')
    //   console.log(this.staticListOfCourseData)
    // },
    mthRegisterIndexProgressByEmailSlug(index, slug, email) {
      //console.log("mamy wszytko?: ", email, index, slug);

      if (
        email &&
        slug &&
        email !== "" &&
        slug !== "" &&
        index &&
        index !== ""
      ) {
        firebase
          .firestore()
          .collection("progressIndicesTracking")
          .doc(email + "_" + slug)
          .set({
            currentindex: index
          });
      } else {
        //console.log("Czegoś brakuje");
      }
    },
    mthConstructLinkToVideoPlayer(vimeoid, index, slug) {
      //console.log("link is:  " + "/course/" + slug + "/video-player/" + vimeoid + "," + index);
      return "/course/" + slug + "/video-player/" + vimeoid + "," + index;
    },
    mthConstructLinkToVideoPlayerIfText(index) {
      /*var textslug = title
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(" ", "-")
      .replace(".", "")
      .replace(".", "")
      .replace(",", "")
      .replace(",", "");
      //console.log("will construct to " + vid);
      return "/course/" + this.courseslug + "/video-player/" + textslug;*/
      if (
        typeof this.courseslug !== "undefined" &&
        typeof index !== "undefined"
      )
        return "/course/" + this.courseslug + "/video-player/" + index;
    },
    mthSlugToLabel(slug) {
      return slug
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ")
        .replace("-", " ");
    },
    mthGetCourseFirebaseDataBySlug(slug) {
      firebase
        .firestore()
        .collection("courses")
        .where("name", "==", this.mthSlugToLabel(slug))
        .limit(1)
        .get()
        .then(result => {
          //console.log(result);
          var data = {};
          result.forEach(doc => {
            //console.log(doc.data());
            this.courseFirebaseData = doc.data(); //course data
          });
        });
    },
    mthToggleCategory(cat) {
      //console.log("will toggle " + cat);
      if (!this.collapsedCategoriesNames.includes(cat))
        this.collapsedCategoriesNames.push(cat);
      else
        this.collapsedCategoriesNames.splice(
          this.collapsedCategoriesNames.indexOf(cat)
        );
      //console.log(this.collapsedCategoriesNames)
    },
    mthToggleSubCategory(subcat) {
      //console.log("will toggle " + subcat);
      if (!this.collapsedSubCategoriesNames.includes(subcat))
        this.collapsedSubCategoriesNames.push(subcat);
      else
        this.collapsedSubCategoriesNames.splice(
          this.collapsedSubCategoriesNames.indexOf(subcat)
        );
    },
    // mthGetmyCategory(subcatname, index) { //index, fuck, this is crazy

    //   console.log('mthGetmyCategory subcat '+subcatname+' index '+index)

    //   let toret = "not found";
    //   let that = this;
    //   let myindex = 0
    //   console.log('%c mthGetmyCategory called subcatname='+subcatname+', index='+index,"color: green")
    //   this.courseFirebaseData.newOrEditedCourseDetails.forEach(el => {
    //     var temp;
    //     if (el.type === "category") {
    //       if (myindex <= index) this.temp = el.data;
    //       console.log("mthGetmyCategory: temp=" + this.temp);
    //     }
    //     if (el.type === "subcategory" || el.data === subcatname) {
    //       console.log('%c index'+index,'color:green')

    //       console.log("%cmthGetmyCategory: my proper cat is: " + this.temp,'color:red');
    //       if (myindex <= index) that.toret = this.temp;
    //     }

    //     myindex++

    //   });
    //   console.log("%cmthGetmyCategory: returning: " + that.toret,'font-weight: bold; font-decoration underline');

    //   return that.toret;
    // },

    mthGetmyCategory2(indexinlist) {
      var candidate = "";

      for (
        var i = 0;
        i < this.courseFirebaseData.newOrEditedCourseDetails.length;
        i++
      ) {
        var el = this.courseFirebaseData.newOrEditedCourseDetails[i];
        if (el.type === "category" && i < indexinlist) {
          //console.log('set candidate to '+el.data)

          this.candidate = el.data;
        }
      }

      //console.log('will return '+this.candidate);

      return this.candidate;
    },

    mthGetmySubCategory(videoname) {
      //or text name
      //iterate collection, remember only cats, subcat causes return and voila
      //console.log("START mthGetmySubCategory");
      //console.log('---mthGetmySubCategory videoname '+videoname)

      var toret = "not found";
      var that = this;

      this.courseFirebaseData.newOrEditedCourseDetails.forEach(el => {
        //console.log("subtype=" + el.type);
        //console.log('data='+el.data);
        var temp;
        if (el.type === "subcategory") {
          this.temp = el.data;
          //console.log("temp=" + this.temp);
        }
        if (
          el.type === "video" &&
          el &&
          el.data &&
          (el.data === videoname || el.data.data.name === videoname)
        ) {
          //console.log("toret=" + this.temp);

          that.toret = this.temp;
        }
      });
      //console.log("will return " + that.toret);

      return that.toret;
    }
  },
  mounted: function() {}
};
